import React from "react";
import { connect } from "react-redux";
import cs from "classnames";

import mapDispatch from "~/misc/mapDispatch";

import GuidCard from "./compontents/GuideCard";
import DetailCard from "./compontents/DetialCard";
import PostTruckList from "./compontents/PostTruckList";
import { POSTTRUCKSHOWTYPE , convertToPosttruck, convertToWeightType} from "./utils";
import { changShowCardAction , selectedPostTruckAction} from "./state/action";

import css from "./style.css";
import { getDeeplink, removeQuery } from "~/misc/getQuery";
import deeplink from "~/misc/deeplink";

const campaignQueryMap = {
  'any': "Any", 
  'min': "up to 26,000 lbs",
  "upperMin":"26,001-33,000 lbs" ,
  "middle":"33,001-40,000 lbs",
  "max":"40,001+ lbs"
}

const parserCampaignQuery = (query) =>{ 
  const obj =  JSON.parse(window.atob(query));
  let data = {
    equipment: (obj.equipment && obj.equipment.length) ? obj.equipment.split(",") : "van",
    weight:  obj.weight ? campaignQueryMap[obj.weight] : "Any",
    length: obj.length || 0
  }

  data.pickup = {
    lat : obj.pickLat , 
    lng : obj.pickLng,
    address: obj.pickCity + ',' + obj.pickState, 
    deadhead: obj.pickDeadHead || 0, 
    state: obj.pickState, 
    city: obj.pickCity
  }

  data.dropoff = {
    lat : obj.dropLat || '', 
    lng : obj.dropLng || '',
    address: obj.dropCity || '', 
    deadhead: obj.dropDeadHead || 0, 
    state: obj.dropState || '', 
    city: obj.dropCity || ''
  }

  return convertToPosttruck(data);
}

const openDeeplink = () => {
  const [isMobile] = removeQuery(['isMobile',"campaignQuery", "token"]);
  if(isMobile) {
    setTimeout(()=> {
      window.location.href = deeplink.openPostTruck({hash: isMobile});
    }, 0)
  }
} 

class PostTruck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showType: this.props.showCard, //  POSTTRUCKSHOWTYPE.GUID_NOVERIFY, // POSTTRUCKSHOWTYPE.LIST,
      selectedData: null,
    };
  }
  componentWillMount() {
    const { selectedPostTruck } = this.props;
    const query = this.props.location.query;
    if(query && query.campaignQuery) {
      console.log(parserCampaignQuery(query.campaignQuery));
      selectedPostTruck(parserCampaignQuery(query.campaignQuery))
      this.props.changeShowCard(POSTTRUCKSHOWTYPE.DETAIL_LOADALERT);
      return;
    }
    const { showCard } = this.props;
    if(showCard === POSTTRUCKSHOWTYPE.DETAIL_LOADALERT) {
      return;
    }
    this.props.changeShowCard(POSTTRUCKSHOWTYPE.LIST);
  }
  componentDidMount() {
    openDeeplink();
  }
  render() {
    const Header = () => {
      return (
        <header className={css.postTruckHeader}>
          <div className={css.title}>Post Truck</div>
          <div className={css.subTitle}>
            Post your capacity to gain higher exposure to premium loads.
          </div>
        </header>
      );
    };

    return (
      <section className={css.postTruck}>
        <Header />
        <main className={css.postTruckMain}>
          {this.props.showCard.includes("GUID") && (
            <GuidCard type={this.props.showCard} />
          )}
          {this.props.showCard.includes("DETAIL") && (
            <DetailCard type={this.props.showCard} />
          )}
          <div
            className={cs({
              [css.hideList]: this.props.showCard !== POSTTRUCKSHOWTYPE.LIST,
            })}
          >
            <PostTruckList />
          </div>
        </main>
      </section>
    );
  }
}

export default connect(
  (state, ownProps) => {
    return {
      ...state.postTruck,
      ...ownProps,
    };
  },
  mapDispatch({
    changeShowCard: (props, type) => changShowCardAction(type),
    selectedPostTruck: (props, formData) => selectedPostTruckAction(formData)
  })
)(PostTruck);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/index.js